import classNames from 'classnames'

import Button from 'shared/components/Button'

import { FilterControlMenu } from './FilterControlMenu'
import { TextAnswersList } from './TextAnswersList'

import styles from '../styles.module.scss'

const FilterView = ({
    filterOptions,
    ratingOptions,
    filterRating,
    setFilterRating,
    filteredFeedbacks,
    areAllVisible,
    onShowMore,
    onDownloadCSV,
}) => (
    <section className={styles.filteredResultsWrap}>
        <div className={classNames('d-flex justify-content-between align-items-baseline', styles.chartDescription)}>
            <h2 className="mt-2">
                <T>nps.admin.dashboard.additional.feedback.label</T>
            </h2>
            <Button size="large" className={styles.downloadCSVBtn} btnStyle="outline" onClick={onDownloadCSV}>
                <T>nps.admin.export.scv</T>
            </Button>
        </div>

        <FilterControlMenu
            filterOptions={filterOptions}
            ratingOptions={ratingOptions}
            filterRating={filterRating}
            setFilterRating={setFilterRating}
        />
        <TextAnswersList filteredFeedbacks={filteredFeedbacks} areAllVisible={areAllVisible} onShowMore={onShowMore} />
    </section>
)

export default FilterView
